import { render, staticRenderFns } from "./AbiturientHomeView.vue?vue&type=template&id=5802845e&scoped=true"
import script from "./AbiturientHomeView.vue?vue&type=script&lang=js"
export * from "./AbiturientHomeView.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/abiturient.css?vue&type=style&index=0&id=5802845e&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5802845e",
  null
  
)

export default component.exports